import { useAppSelector } from 'redux/hooks/reduxHooks';
import { select12HourFormat, selectUserLocale } from 'redux/selectors/selectors';

export const useDebateDateTime = (unixTS: number) => {
  const is12HourFormat = useAppSelector(select12HourFormat);
  const userLocale = useAppSelector(selectUserLocale);
  const date = new Date(unixTS * 1000);

  const formattedDate = new Intl.DateTimeFormat(is12HourFormat ? 'en-US' : 'en-GB', {
    day: 'numeric',
    month: 'short',
    year: '2-digit',
  }).format(date);

  const formattedTime = new Intl.DateTimeFormat(userLocale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: is12HourFormat,
  }).format(date);

  return {
    date: is12HourFormat
      ? formattedDate.replace(', ', ' ‘')
      : formattedDate.replace(/(\d{2})$/, '‘$1'),
    time: formattedTime,
  };
};
